var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrfDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EBF9F5",
    width: 24,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.763 16.366h6.105c.163 0 .3-.052.403-.163a.537.537 0 0 0 .163-.404c0-.163-.051-.3-.163-.403a.537.537 0 0 0-.403-.164H8.763c-.163 0-.3.052-.403.164a.571.571 0 0 0-.163.403c0 .163.051.3.163.404.111.103.24.163.403.163zm0-2.087h6.105c.163 0 .3-.051.403-.163a.537.537 0 0 0 .163-.403c0-.163-.051-.3-.163-.404a.537.537 0 0 0-.403-.163H8.763c-.163 0-.3.052-.403.163a.537.537 0 0 0-.163.404c0 .163.051.3.163.403.111.112.24.163.403.163zm-1.691 5.306c-.3 0-.567-.111-.799-.343a1.098 1.098 0 0 1-.343-.799V5.557c0-.301.112-.567.343-.799.224-.223.49-.343.799-.343h6.37c.155 0 .3.034.447.094.146.06.266.146.369.25l3.469 3.468c.103.103.18.223.249.369.06.146.094.292.094.446v9.401c0 .301-.112.567-.343.799-.224.223-.49.343-.799.343H7.072zM13.357 8.52V5.565H7.08v12.887h9.857V9.085h-3.014a.525.525 0 0 1-.403-.163.537.537 0 0 1-.163-.403zm-2.945 2.395V7.892A.388.388 0 0 0 10.3 7.6a.388.388 0 0 0-.292-.112.388.388 0 0 0-.292.112.388.388 0 0 0-.111.292v3.022c0 .12.034.215.111.292a.388.388 0 0 0 .292.111c.12 0 .215-.034.292-.111a.388.388 0 0 0 .112-.292zM8.626 9.806h2.756c.12 0 .214-.034.292-.111a.388.388 0 0 0 .111-.292.388.388 0 0 0-.111-.292.388.388 0 0 0-.292-.112H8.626a.388.388 0 0 0-.292.112.388.388 0 0 0-.112.292c0 .12.035.215.112.292a.388.388 0 0 0 .292.111z",
    fill: "#01B37A",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrfDoc);
export default __webpack_public_path__ + "static/media/trf-doc.3b2cfb61701b32f7eb8289c0837b733d.svg";
export { ForwardRef as ReactComponent };